import React, { FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';

import styles from './CheckMark.module.css';
import checkMarkPath from './paths';

const CheckMarkIcon: FC = () => {
  const { iconsPrimaryNone: style } = useTheme();

  return (
    <svg
      className={styles.container}
      style={{
        fill: style?.color,
        ...style,
      }}
      viewBox="0 0 48 48"
      role="presentation"
    >
      <path d={checkMarkPath} />
    </svg>
  );
};

export default CheckMarkIcon;
